import { createContext, useState } from "react";

export const InvoiceContext = createContext();
const InvoiceProvider = ({children}) =>{
    const [invoices,setInvoices] = useState(null);
    const [reloadInvoices,setReloadInvoices] = useState(false);
    const [showNewInvoiceWindow,setShowNewInvoiceWindow] = useState(false);
    const [selectedToDeleteInvoice,setSelectedToDeleteInvoice] = useState(null);
    const [selectedToCancelInvoice,setSelectedToCancelInvoice] = useState(null);
    const [selectedInvoiceSummary,setSelectedInvoiceSummary] = useState(null);
    const [selectedInvoice,setSelectedInvoice] = useState(null);
    return(
        <InvoiceContext.Provider value={{
            invoices,setInvoices,
            reloadInvoices,setReloadInvoices,
            showNewInvoiceWindow,setShowNewInvoiceWindow,
            selectedToDeleteInvoice,setSelectedToDeleteInvoice,
            selectedToCancelInvoice,setSelectedToCancelInvoice,
            selectedInvoiceSummary,setSelectedInvoiceSummary,
            selectedInvoice,setSelectedInvoice
        }}>{children}</InvoiceContext.Provider>
    );
};
export default InvoiceProvider;